import React from 'react';
import { ClayMark } from './ClayLogo';

interface LoadingSpinnerProps {
  message?: string;
  fullPage?: boolean;
  dark?: boolean;
  size?: 'sm' | 'md';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message,
  fullPage = false,
  dark = false,
  size = 'md',
}) => {
  const markSize = size === 'sm' ? 32 : 56;
  const textClass = dark ? 'text-line' : 'text-body';
  const textSize = size === 'sm' ? 'text-sm' : 'text-base';

  if (fullPage) {
    return (
      <div className="viewport-shell flex items-center justify-center bg-cloud p-6">
        <div className="flex flex-col items-center gap-4 text-center" role="status">
          <ClayMark size={56} className="db-loading-clay" />
          {message && <p className="text-body">{message}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-4" role="status">
      <ClayMark size={markSize} className="db-loading-clay" />
      {message && <p className={`${textClass} ${textSize} mt-2`}>{message}</p>}
    </div>
  );
};
